import styled from 'styled-components';

export const GoogleButtonWrapper = styled.div`
  width: 100%;
  display: flex;
`;

export const HiddenGoogleButton = styled.div`
  display: none;
`;
